<template>
  <div class="sidebar-page">
    <div class="sidebar-wrapper">
      <nav :class="{ sidebar: true, sidebarStatic: true, sidebarOpened: true }" @mouseenter="sidebarMouseEnter" @mouseleave="sidebarMouseLeave">
        <header class="logo">
          <router-link :to="getUserInitPage"><span class="primary-word">T-deal Partner</span> Admin</router-link>
        </header>
        <ul class="nav">
          <template v-for="(menu, index) in clickRewardMenuList">
            <NavLink
              :activeItem="activeItem"
              :header="menu.header"
              :link="menu.link"
              :iconName="menu.iconName"
              :childrenLinks="menu.childrenLinks || []"
              isHeader
              :key="`${menu.link}-${index}`"
            />
          </template>

          <NavLink v-if="isDev" :activeItem="activeItem" :header="'정산'" :link="'/settlement/view'" :iconName="'coin'" :index="`list0`" isHeader :key="0" />
          <NavLink :activeItem="activeItem" :header="'페널티 현황'" :link="'/penalty/view'" :iconName="'clipboard-data'" isHeader :key="1" />
          <NavLink :activeItem="activeItem" :header="'서비스 불만율'" :link="'/complaint/view'" :iconName="'headset'" :index="`list0`" isHeader :key="2" />
          <NavLink :activeItem="activeItem" :header="'계약 이력'" :link="'/contractHistory/view'" :iconName="'clock-history'" :index="`list0`" isHeader :key="3" />
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import isScreen from '@/core/screenHelper'
import NavLink from './navLink/NavLink'

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      clickRewardMenuList: [],
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.changeSidebarActive(paths.join('/'))
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false)
        this.setActiveByRoute()
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }
    },
    initClickRewardMenuList() {
      const isProd = process.env.VUE_APP_BUILD_ENV === 'prod'

      const krTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' });
      const targetDate = new Date('2025-04-14T00:00:00+09:00');
      
      // 실제 코드는 아래처럼 사용
      const isAfterApril14 = targetDate <= new Date(krTime);
      if (!isProd || isAfterApril14) {
        this.clickRewardMenuList = [
          {
            link: '/ad',
            header: '광고 관리',
            // iconName: 'flaticon-user-3',
            childrenLinks: [
              {
                link: '/ad/requests',
                header: '광고 신청',
              },
              {
                link: '/ad/campaign-reports',
                header: '캠페인 리포트',
              },
            ],
          },
        ]
      }
    }
  },
  created() {
    this.setActiveByRoute()

    this.initClickRewardMenuList()
  },
  computed: {
    isDev() {
      const now = new Date()
      const open = new Date('2024-12-01 00:00:00')
      return now >= open
    },
    ...mapState('layout', {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement
    }),
    ...mapState('authentication', ['userInfo']),
    ...mapGetters('authentication', ['getUserInfo', 'getUserInitPage'])
  }
}
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped></style>
